export function registerPwa() {
  // Development hot reload and the native Capacitor container do not use this worker.
  if (process.env.NODE_ENV !== 'production' || !window.isSecureContext || !('serviceWorker' in navigator) ||
      (window as Window & { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor?.isNativePlatform?.()) return;
  const register = () => {
    navigator.serviceWorker.register('/service-worker.js', { scope: '/', updateViaCache: 'none' })
      .catch(error => console.warn('AvatarMe: не удалось подготовить приложение к установке', error));
  };
  if (document.readyState === 'complete') register();
  else window.addEventListener('load', register, { once: true });
}
